import { render, staticRenderFns } from "./ChallengeValidationModal.vue?vue&type=template&id=582913c4"
import script from "./ChallengeValidationModal.vue?vue&type=script&lang=js"
export * from "./ChallengeValidationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports